import * as firebase from 'firebase'

export default {
  state: {
    loadedTrials: [
      {
        trialId: 'tri',
        trialName: 'Trial Sample',
        trialEnrollment: '',
        trialLocations: [],
        trialIndications: [],
        trialInvestigators: [],
        trialCoordinators: [],
        trialDescription: '',
        trialLink: ''
      }
    ]
  },
  mutations: {
    setLoadedTrials (state, payload) {
      state.loadedTrials = payload
    },
    createTrial (state, payload) {
      // payload.trialID = key
      console.log('ID: ' + payload.trialId)
      state.loadedTrials.push(payload)
    },
    updateTrial (state, payload) {
      const trial = state.loadedTrials.find(trial => {
        return trial.trialId === payload.trialId
      })
      if (payload.trialName) {
        trial.trialName = payload.trialName
      }
      if (payload.trialEnrollment) {
        trial.trialEnrollment = payload.trialEnrollment
      }
      if (payload.description) {
        trial.trialDescription = payload.description
      }
      if (payload.trialLocations) {
        trial.trialLocations = payload.trialLocations
      }
      if (payload.trialIndications) {
        trial.trialIndications = payload.trialIndications
      }
      if (payload.trialInvestigators) {
        trial.trialInvestigators = payload.trialInvestigators
      }
      if (payload.trialCoordinators) {
        trial.trialCoordinators = payload.trialCoordinators
      }
    },
    deleteTrial (state, payload) {
      const trial = state.loadedTrials.find(function (trial) {
        return trial.trialId === payload.trialId
      })
      var todos = state.loadedTrials
      todos.splice(todos.indexOf(trial), 1)
    }
  },
  actions: {
    loadTrials ({commit}) {
      commit('setLoading', true)
      firebase.database().ref('trials').once('value')
        .then((data) => {
          const trials = []
          const obj = data.val()
          for (let key in obj) {
            // * END OF FIREBASE TREE DATA SETTING FOR LOCATIONS, INDICATIONS, INVESTIGATORS, AND COORDINATORS *
            // Then, push all data to be set in the setLoadedTrials mutation.
            trials.push({
              trialId: key,
              trialName: obj[key].trialName,
              trialEnrollment: obj[key].trialEnrollment,
              trialDescription: obj[key].trialDescription,
              trialLocations: obj[key].trialLocations,
              trialIndications: obj[key].trialIndications,
              trialInvestigators: obj[key].trialInvestigators,
              trialCoordinators: obj[key].trialCoordinators,
              trialLink: obj[key].trialLink,
              creatorId: obj[key].creatorId
            })
          }
          commit('setLoadedTrials', trials)
          commit('setLoading', false)
        })
        .catch(
          (error) => {
            console.log(error)
            commit('setLoading', true)
          }
        )
    },
    createTrial ({commit, getters}, payload) {
      const trial = {
        trialName: payload.title,
        trialEnrollment: payload.trialEnrollment,
        trialDescription: payload.description,
        trialLocations: payload.trialLocations,
        trialIndications: payload.trialIndications,
        trialInvestigators: payload.trialInvestigators,
        trialCoordinators: payload.trialCoordinators,
        trialLink: payload.trialLink,
        // trialId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'location_on',
        creatorId: getters.user.id
      }
      firebase.database().ref('trials').push(trial)
        .then((snap) => {
          trial.trialId = snap.key
          console.log('This Firebase New trial: ' + JSON.stringify(trial))
          console.log('THE SNAP KEY: ' + trial.trialId)
          commit('createTrial', {
            ...trial
          })
        })
        .catch((error) => {
          console.log(error)
        })
      // Reach out to firebase and store it
      // commit('createTrial', trial)
    },
    // May have to create a separate Action for each updated item (i.e. updateTrialLocation, updateTrialDescription, etc)
    updateTrialData ({commit}, payload) {
      commit('setLoading', true)
      // const updateObj = {}
      if (payload.trialName) {
        const updateObjName = {}
        updateObjName.trialName = payload.trialName
        firebase.database().ref('trials').child(payload.trialId).update(updateObjName)
        .then(() => {
          commit('setLoading', false)
          commit('updateTrial', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
      }
      if (payload.trialEnrollment) {
        const updateObjEnrollment = {}
        updateObjEnrollment.trialEnrollment = payload.trialEnrollment
        console.log('LOOK: ' + JSON.stringify(updateObjEnrollment))
        firebase.database().ref('trials').child(payload.trialId).update(updateObjEnrollment)
        .then(() => {
          commit('setLoading', false)
          commit('updateTrial', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
      }
      if (payload.trialLink) {
        const updateObjLink = {}
        updateObjLink.trialLink = payload.trialLink
        firebase.database().ref('trials').child(payload.trialId).update(updateObjLink)
        .then(() => {
          commit('setLoading', false)
          commit('updateTrial', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
      }
      if (payload.description) {
        const updateObjDescription = {}
        updateObjDescription.trialDescription = payload.description
        firebase.database().ref('trials').child(payload.trialId).update(updateObjDescription)
        .then(() => {
          commit('setLoading', false)
          commit('updateTrial', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
      }
      if (payload.trialLocations) {
        const updateObjLocation = {}
        updateObjLocation.trialLocations = payload.trialLocations
        firebase.database().ref('trials').child(payload.trialId).update(updateObjLocation)
        .then(() => {
          commit('setLoading', false)
          commit('updateTrial', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
      }
      if (payload.trialIndications) {
        const updateObjIndication = {}
        updateObjIndication.trialIndications = payload.trialIndications
        firebase.database().ref('trials').child(payload.trialId).update(updateObjIndication)
        .then(() => {
          commit('setLoading', false)
          commit('updateTrial', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
      }
      if (payload.trialInvestigators) {
        const updateObjInvestigator = {}
        updateObjInvestigator.trialInvestigators = payload.trialInvestigators
        firebase.database().ref('trials').child(payload.trialId).update(updateObjInvestigator)
        .then(() => {
          commit('setLoading', false)
          commit('updateTrial', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
      }
      if (payload.trialCoordinators) {
        const updateObjCoordinator = {}
        updateObjCoordinator.trialCoordinators = payload.trialCoordinators
        firebase.database().ref('trials').child(payload.trialId).update(updateObjCoordinator)
        .then(() => {
          commit('setLoading', false)
          commit('updateTrial', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
      }
    },
    deleteTrialData ({commit}, payload) {
      commit('setLoading', true)
      console.log(JSON.stringify(payload))
      firebase.database().ref('trials').child(payload.trialId).remove()
      .then(() => {
        commit('setLoading', false)
        commit('deleteTrial', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    }
  },
  getters: {
    loadedTrials (state) {
      return state.loadedTrials.sort((trialA, trialB) => {
        return trialA.trialEnrollment.enrollmentPriority - trialB.trialEnrollment.enrollmentPriority
      })
    },
    loadedTrialsByEnrollment (state) {
      return (someId) => {
        var result = state.loadedTrials.filter((trial) => {
          if (trial.trialEnrollment) {
            console.log('LENGTH: ' + trial.trialEnrollment.length)
            for (let i = 0; i < trial.trialEnrollment.length; i++) {
              return trial.trialEnrollment[i].enrollmentId === someId
            }
          }
        })
        return result
      }
    },
    loadedTrialsByLocation (state) {
      return (someId) => {
        const hold = []
        state.loadedTrials.filter((trial) => {
          if (trial.trialLocations) {
            console.log('LENGTH: ' + trial.trialLocations.length)
            for (let i = 0; i < trial.trialLocations.length; i++) {
              console.log('INDIES' + [i] + ': ' + trial.trialLocations[i])
              if (trial.trialLocations[i] === someId) {
                hold.push(trial)
              }
            }
          }
        })
        return hold
      }
    },
    loadedTrialsByIndication (state) {
      return (someId) => {
        const hold = []
        state.loadedTrials.filter((trial) => {
          if (trial.trialIndications) {
            console.log('LENGTH: ' + trial.trialIndications.length)
            for (let i = 0; i < trial.trialIndications.length; i++) {
              console.log('INDIES' + [i] + ': ' + trial.trialIndications[i])
              if (trial.trialIndications[i] === someId) {
                hold.push(trial)
              }
            }
          }
        })
        return hold
      }
    },
    loadedTrialsByInvestigator (state) {
      return (someId) => {
        const hold = []
        state.loadedTrials.filter((trial) => {
          if (trial.trialInvestigators) {
            console.log('LENGTH: ' + trial.trialInvestigators.length)
            for (let i = 0; i < trial.trialInvestigators.length; i++) {
              console.log('INDIES' + [i] + ': ' + trial.trialInvestigators[i])
              if (trial.trialInvestigators[i] === someId) {
                hold.push(trial)
              }
            }
          }
        })
        return hold
      }
    },
    loadedTrialsByCoordinator (state) {
      return (someId) => {
        const hold = []
        state.loadedTrials.filter((trial) => {
          if (trial.trialCoordinators) {
            console.log('LENGTH: ' + trial.trialCoordinators.length)
            for (let i = 0; i < trial.trialCoordinators.length; i++) {
              console.log('INDIES' + [i] + ': ' + trial.trialCoordinators[i])
              if (trial.trialCoordinators[i] === someId) {
                hold.push(trial)
              }
            }
          }
        })
        return hold
      }
    },
    featuredTrials (state, getters) {
      return getters.loadedTrials.slice(0, 5)
    },
    loadedTrial (state) {
      return (someId) => {
        return state.loadedTrials.find((trial) => {
          console.log(trial.trialId + ' + ' + someId)
          return trial.trialId === someId
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/trial/index.js